import React from 'react';
import { Link } from 'react-router-dom';
import styles from './footer.module.css';

import vk from '../../images/social/vk.svg'
import discord from '../../images/social/discord.svg'

import mir from '../../images/pay/mir.svg'
import sbp from '../../images/pay/sbp.svg'

import Logo from '../logo/Logo';
import { TFooter } from '../../utils/types';
import { onPanelLinkClick, onPanelLinkHover } from '../../utils/panelLink';
import { useSiteConfig } from '../../contexts/SiteConfigContext';

// Футер в обычном потоке страницы на всех страницах: раньше на главной он
// накрывал низ последней секции, а на донате был fixed и закрывал кнопку оплаты.
// Над футером — плавный градиентный переход (::before).
const Footer: React.FC<TFooter> = ({ type, serverStatus }) => {
  const { links, documents } = useSiteConfig();

  return (
    <footer className={`${styles.footer} ${type === 'main' ? styles.footerMain : ''}`}>
      <div className={styles.mainContainer}>
        <div className={styles.topContainer}>
          <div className={styles.brand}>
            <Link to="/" className={styles.brandLogo} aria-label="AmazingLife — RPG, на главную">
              <Logo />
              <span className={styles.brandName}>AmazingLife — RPG</span>
            </Link>
            <p className={styles.tagline}>Ролеплей проект на платформе Arma 3</p>
            <p className={styles.serverStatusContainer}>
              Статус сервера
              <span
                className={`${styles.serverStatus} ${serverStatus.status ? styles.serverStatusOk : styles.serverStatusKo}`}
                aria-label={serverStatus.status ? 'работает' : 'недоступен'}
                role="img"
              />
            </p>
            <div className={styles.socials}>
              <a href={links.vk} target="_blank" rel="noopener noreferrer" className={styles.imgLinks}><img alt="vk" className={styles.imgSocial} src={vk} /></a>
              <a href={links.discord} target="_blank" rel="noopener noreferrer" className={styles.imgLinks}><img alt="discord" className={styles.imgSocial} src={discord} /></a>
            </div>
          </div>
          <div className={styles.col}>
            <p className={styles.colTitle}>Игрокам</p>
            <a href={links.forum} className={styles.link}>Форум</a>
            <a href="/panel" className={styles.link} onClick={e => onPanelLinkClick(e, '/panel')} onMouseEnter={onPanelLinkHover} onFocus={onPanelLinkHover}>Личный кабинет</a>
            <Link to="/donate" className={styles.link}>Пополнить счет</Link>
            <Link to="/rules" className={styles.link}>Правила и инструкции</Link>
          </div>
          <div className={styles.col}>
            <p className={styles.colTitle}>Поддержка</p>
            <a href={links.support_discord} target="_blank" rel="noopener noreferrer" className={styles.link}>Поддержка в Discord</a>
            <a href={links.support_vk} target="_blank" rel="noopener noreferrer" className={styles.link}>Поддержка в VK</a>
          </div>
          {/* Адрес и название берём у активной версии документа в разделе «Документы» */}
          <div className={`${styles.col} ${styles.documents}`}>
            <p className={styles.colTitle}>Документы</p>
            {['tos', 'offer', 'privacy'].map(slug => {
              const doc = documents[slug];
              return doc ? (
                <a key={slug} href={doc.url} target="_blank" rel="noopener noreferrer" className={styles.link}>{doc.title}</a>
              ) : null;
            })}
          </div>
          <div className={styles.payTypes}>
            <p className={styles.colTitle}>Оплата</p>
            <div className={styles.payIcons}>
              <img alt="Мир" className={styles.img} src={mir} />
              <img alt="СБП" className={styles.img} src={sbp} />
            </div>
          </div>
        </div>
        <div className={styles.bottomContainer}>
          <div className={styles.company}>
            <b>ИП Вологузов Александр Андреевич</b>
            <span>ИНН 330576809809</span>
            <span>ОГРНИП 324330000033371</span>
          </div>
          <p className={styles.copyright}>© {new Date().getFullYear()} AmazingLife — RPG</p>
        </div>
        <p className={styles.textDisclamer}>AmazingLife — RPG не является аффилированным лицом и не одобрено Bohemia Interactive или другим правообладателем. Все используемые товарные знаки принадлежат их соответствующим владельцам.</p>
      </div>
    </footer>
  );
}

export default Footer;
